export default "__VITE_ASSET__C$apFnmr__"